import { Component, ElementRef, Input, viewChild, ViewChild, signal, computed } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule } from '@angular/forms'

import { ActivatedRoute, Router } from '@angular/router'
import { TreeNode, MessageService } from '@openng/optimus-ui/api'
import { graphic } from 'echarts/core'
import { TableModule } from '@openng/optimus-ui/table'
import { OrganizationChartModule } from '@openng/optimus-ui/organizationchart'
import { ProgressBarModule } from '@openng/optimus-ui/progressbar'
import { FieldsetModule } from '@openng/optimus-ui/fieldset'
import { MenuModule } from '@openng/optimus-ui/menu'
import { ButtonModule } from '@openng/optimus-ui/button'
import { SkeletonModule } from '@openng/optimus-ui/skeleton'
import { DockModule } from '@openng/optimus-ui/dock'
import { TreeTableModule } from '@openng/optimus-ui/treetable'
import { PanelModule } from '@openng/optimus-ui/panel'
import { NgxEchartsModule } from 'ngx-echarts'
import { echarts } from '../../../_shared/echarts-setup'
import { DialogModule, Dialog } from '@openng/optimus-ui/dialog'
import { TooltipModule } from '@openng/optimus-ui/tooltip'
import { BadgeModule } from '@openng/optimus-ui/badge'
import { MessageModule } from '@openng/optimus-ui/message'
import { SpeedTestFortiComponent } from '../speedtest/speedtestComponent/speedtest'
import { WorkflowManagerApiService } from '../../../_services'
import { FuseqTableComponent } from '../../../FuseQ/fuseq-modules/fuseqTable/fqtable.component'
import { SpeedtestHistoryTableComponent } from '../../speedTestAWP/speedtest-history-table/speedtest-history-table.component'
import { FqConfirmService } from '../../../shared/fq-confirm.service'
import { FqDialogNavComponent } from '../../../shared/fq-dialog-nav.component'
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome'
interface BandwidthPoint {
  bps: number
  utc_ms: number
}
interface BandwidthResponse {
  last_rx: number
  last_tx: number
  rx: BandwidthPoint[]
  tx: BandwidthPoint[]
}
interface SdWanMember {
  name: string
  active: boolean
}
interface SdWanRule {
  name: string
  hit_count: number
  dst_interfaces: SdWanMember[]
  enabled: boolean
}
interface SlaEvent {
  timestamp: number
  sla_name: string
  latency: number
  jitter: number
  packetloss: number
  latency_status?: string
  jitter_status?: string
  packetloss_status?: string
}
import { OptimUiSharedModule } from '../../../shared/optimus-ui-shared.module';
@Component({
  standalone: true,
  selector: 'fortinet-details',
  templateUrl: 'fortinetDetails.component.html',
  styleUrls: ['./fortinetDetails.component.scss'],
  imports: [OptimUiSharedModule, CommonModule, FormsModule, FontAwesomeModule, TableModule, OrganizationChartModule, ProgressBarModule, FieldsetModule, MenuModule, ButtonModule, SkeletonModule, DockModule, TreeTableModule, PanelModule, NgxEchartsModule, DialogModule, TooltipModule, BadgeModule, MessageModule, SpeedTestFortiComponent, FuseqTableComponent, SpeedtestHistoryTableComponent, FqDialogNavComponent]
})

export class FortinetDetailsComponent {
  @Input() showFortinetDetails: boolean = false
  @Input() standalone: boolean = false
  @Input() set frazionario (value: string | null) {
    // console.log('Frazionario changed to:', value)
    this._frazionario = value
    if (value && value !== null) {
      if (value !== this._frazionario) {
        this.showFortinetDetails = true
      }
      this.refreshData(value)
    }
  }

  get frazionario (): string | null {
    return this._frazionario
  }

  private _frazionario: string | null = null

  constructor (
    private readonly messageService: MessageService,
    private readonly workflowApiService: WorkflowManagerApiService,
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly fqConfirm: FqConfirmService
  ) {
  }

  @ViewChild('fortigatedetails') fortigatedetailsElement!: ElementRef
  @ViewChild('fexdetails') fexdetailsElement!: ElementRef
  @ViewChild('workflow') workflowElement!: ElementRef
  @ViewChild('healthcheck') healthcheckElement!: ElementRef
  @ViewChild('tunnels') tunnelsElement!: ElementRef
  @ViewChild('cpumem') cpumemElement!: ElementRef
  @ViewChild('traffic') trafficElement!: ElementRef
  @ViewChild('trafficbytes') trafficbytesElement!: ElementRef
  @ViewChild('sdwanrules') sdwanrulesElement!: ElementRef
  @ViewChild('interfaces') interfacesElement!: ElementRef
  @ViewChild('tasks') tasksElement!: ElementRef
  @ViewChild('switch') switchElement!: ElementRef
  @ViewChild('speedtest', { static: false }) speedtestElement!: ElementRef
  @ViewChild('mySelect') mySelect!: ElementRef
  @ViewChild('mySelect_int') mySelectInt!: ElementRef
  @ViewChild('mySelectSla') mySelectSla!: ElementRef
  items = [
    {
      label: 'Device',
      items: [
        {
          label: 'Workflow',
          icon: 'fa fa-sitemap',
          command: () => {
            this.scrollTo('workflow')
          }
        },
        {
          label: 'CPU & Memory',
          icon: 'fa fa-temperature-high',
          command: () => {
            this.scrollTo('cpumem')
          }
        },
        {
          label: 'Fortigate',
          icon: 'fa fa-circle-info',
          command: () => {
            this.scrollTo('fortigatedetails')
          }
        },
        {
          label: 'FEX',
          icon: 'fa fa-circle-info',
          command: () => {
            this.scrollTo('fexdetails')
          }
        },
        {
          label: 'Health Check',
          icon: 'fa fa-heartbeat',
          command: () => {
            this.scrollTo('healthcheck')
          }
        },
        {
          label: 'Tunnels',
          icon: 'fa fa-satellite-dish',
          command: () => {
            this.scrollTo('tunnels')
          }
        },
        {
          label: 'Traffic',
          icon: 'fa fa-tower-broadcast',
          command: () => {
            this.scrollTo('traffic')
          }
        },
        {
          label: 'Traffic Bytes',
          icon: 'fa fa-traffic-light',
          command: () => {
            this.scrollTo('trafficbytes')
          }
        },
        {
          label: 'SDWAN Rules',
          icon: 'fa fa-network-wired',
          command: () => {
            this.scrollTo('sdwanrules')
          }
        },
        {
          label: 'Interfaces',
          icon: 'fa fa-ethernet',
          command: () => {
            this.scrollTo('interfaces')
          }
        },
        {
          label: 'Switch',
          icon: 'fa fa-plug',
          command: () => {
            this.scrollTo('switch')
          }
        },
        {
          label: 'Tasks',
          icon: 'fa fa-list-check',
          command: () => {
            this.detailTab = 'tasks'
            setTimeout(() => this.scrollTo('tasks'))
          }
        },
        {
          label: 'SpeedTest',
          icon: 'fa-solid fa-gauge-high',
          command: () => {
            this.detailTab = 'speedtest-new'
            setTimeout(() => this.scrollTo('speedtest'))
          }
        }
      ]
    }
  ]

  slaCharts = signal<any[]>([])
  detailTab = 'speedtest-new'
  detailSections = [
    { key: 'speedtest-new', label: 'Speedtest (new)' },
    { key: 'speedtest-old', label: 'Speedtest (old)' },
    { key: 'tasks', label: 'FortiManager Tasks' }
  ]
  filteredInterfaces = computed(() => this.newInterfaces().filter(i => i.name === 'lan3.2' || i.name === 'internal3.2'))
  orgChart: TreeNode[] = []
  rawData = signal<any[]>([])
  chartOption = signal<any>({})
  itemDetails = signal<any>(null)
  newInterfaces = signal<any[]>([])
  itemRules = signal<any[]>([])
  trafficBytes = signal<any[]>([])
  fakeData = [{ key: 'fake', value: 'fake' }, { key: 'fake2', value: 'fake2' }, { key: 'fake3', value: 'fake3' }, { key: 'fake4', value: 'fake4' }, { key: 'fake5', value: 'fake5' }, { key: 'fake6', value: 'fake6' }, { key: 'fake7', value: 'fake7' }, { key: 'fake8', value: 'fake8' }, { key: 'fake9', value: 'fake9' }, { key: 'fake10', value: 'fake10' }, { key: 'fake11', value: 'fake11' }, { key: 'fake12', value: 'fake12' }, { key: 'fake13', value: 'fake13' }, { key: 'fake14', value: 'fake14' }, { key: 'fake15', value: 'fake15' }]
  visibleReboot = false
  visible = false
  dialogTask = null
  hardware = []
  sensorsList = []
  interfaceList = computed(() => this.itemDetails()?.interfaces?.filter((i: any) => i.monitor_bandwidth === true).map((i: any) => i.name) ?? [])
  deviceMapFEX = signal<any[]>([])
  deviceMap = signal<any[]>([])
  isFullExpanded = signal<boolean[]>([])
  view = signal<boolean>(false)
  /* async ngOnInit(): Promise<void> {
    const id = this.route.snapshot.paramMap.get('id')
    console.log(id)
    await this.getDeviceDetails(id)
  } */

  formatter (value) {
    return JSON.stringify(value, null, 2)
  }

  refreshData (value) {
    this.chartOptionBanda.set({})
    this.deviceMapFEX.set([])
    this.deviceMap.set([])
    this.view.set(false)
    this.isFullExpanded.set([])
    this.switchPorts.set([])
    this.ports3_4.set([])
    this.gigabitPorts.set([])
    this.itemDetails.set(null)
    this.itemRules.set([])
    this.trafficBytes.set([])
    this.orgChart = []
    this.rawData.set([])
    this.hardware = []
    this.sensorsList = []
    this.newInterfaces.set([])
    this.slaCharts.set([])
    this.IndirizzamentoSwitch.set('')
    this.Marca.set('')
    if (this.mySelectSla) {
      this.timeSlaRange = '10min'
      this.mySelectSla.nativeElement.value = '10min'
    }
    if (this.mySelect) {
      this.mySelect.nativeElement.value = 'hour'
      this.timeRange = 'hour'
    }
    if (this.mySelectInt) {
      this.mySelectInt.nativeElement.value = ''
      this.chartInterface = ''
    }
    this.rawDataBanda = []
    this.resetHealtCheck()
    this.getDeviceDetails(value)
    // this.getFEXInfo()
  }

  showTaskDialog (task) {
    task.activity_data = task.Payload?.activity || (task.Payload?.data ? task.Payload.data[0]?.activity : []) || []
    this.dialogTask = task
    this.visible = true
  }

  overlayVisible = signal<boolean>(false)

  /**
   * Workaround Optimus: la direttiva `pAutoFocus` imposta l'attributo `autofocus`
   * su ogni `p-button` quando il valore è `undefined` (bug: controlla `=== false`).
   * Il browser esegue quindi l'auto-focus nativo sul primo pulsante del dialog,
   * che su pagine standalone (es. /sdwanmonitor) è a metà pagina, facendo
   * scorrere il contenuto. Riportiamo il contenuto in cima all'apertura.
   */
  onDialogShow (dialog: Dialog): void {
    dialog.maximize()

    const scrollTop = (): void => {
      const content = dialog.contentViewChild?.nativeElement as HTMLElement | undefined
      if (content) {
        content.scrollTop = 0
      }
    }

    scrollTop()
    setTimeout(scrollTop, 0)
  }

  scrollTo (element) {
    this.overlayVisible.set(true)

    setTimeout(() => {
      this.overlayVisible.set(false)
    }, 1500) // durata dell'effetto (puoi modificarla)

    if (this[element + 'Element']) {
      this[element + 'Element'].nativeElement.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      })
      this.highlightTable(element)
    }
  }

  highlightTable (element) {
    const table = this[element + 'Element'].nativeElement
    this.overlayVisible.set(true) // mostra overlay
    table.classList.add('focus-table')

    setTimeout(() => {
      table.classList.remove('focus-table')
      this.overlayVisible.set(false) // rimuove overlay
    }, 1500) // durata in millisecondi
  }

  getTunnelStatus (interfaceName: string): string {
    return this.itemDetails()?.tunnels?.find(tunnel => tunnel.name === interfaceName)?.status || null
  }

  deviceMAPFEX (obj: any): Array<{ key: string, value: any }> {
    if (!obj) return []
    const columnsOrder = [
      { key: 'fex_sn', header: 'SN' },
      { key: 'fex_hostname', header: 'Hostname' },
      { key: 'connect_status', header: 'Status' },
      { key: 'fex_mac', header: 'MAC' },
      { key: 'sim_service', header: 'SIM Service' },
      { key: 'sim_rssi', header: 'RSSI' },
      { key: 'sim_signal_rsrp', header: 'RSRP ' },
      { key: 'sim_signal_rsrq', header: 'RSRQ' },
      { key: 'sim_signal_strength', header: 'Signal Strength' },
      // { key: 'sim_carrier', header: 'Carrier' },
      { key: 'sim_iccid', header: 'ICCID' },
      // { key: 'sim_imsi', header: 'IMSI' },
      { key: 'fex_revision', header: 'Revision' },
      { key: 'fex_version', header: 'Version' }

    ]
    const orderedObj = Object.keys(obj).sort((a, b) => {
      return columnsOrder.findIndex(col => col.key === a) - columnsOrder.findIndex(col => col.key === b)
    }).reduce((acc, key) => {
      acc[key] = obj[key]
      return acc
    }, {})

    return Object.entries(orderedObj).filter(([key]) => columnsOrder.find(col => col.key === key)).map(([key, value]) => ({ key, value, header: columnsOrder.find(col => col.key === key)?.header }))
  }

  deviceMAP (obj: any): Array<{ key: string, value: any }> {
    if (!obj) return []
    const columnsOrder = [
      { key: 'sn', header: 'SN' },
      { key: 'hostname', header: 'Hostname' },
      { key: 'conf_status', header: 'Conf Status' },
      // { key: 'conn_mode', header: 'Mode' },
      { key: 'conn_status', header: 'Status' },
      { key: 'ip', header: 'IP' },
      { key: 'fex_cnt', header: 'FEX Count' },
      { key: 'firmware', header: 'Firmware' },
      { key: 'first_tunnel_up', header: 'First tunnelup' },
      { key: 'uptime', header: 'Uptime' }
      // { key: 'release_type', header: 'Release type' },

    ]
    const orderedObj = Object.keys(obj).sort((a, b) => {
      return columnsOrder.findIndex(col => col.key === a) - columnsOrder.findIndex(col => col.key === b)
    }).reduce((acc, key) => {
      acc[key] = obj[key]
      return acc
    }, {})

    return Object.entries(orderedObj).filter(([key]) => columnsOrder.find(col => col.key === key)).map(([key, value]) => ({ key, value, header: columnsOrder.find(col => col.key === key)?.header }))
  }

  convertDate (unix) {
    const conv = new Date(Number(unix))
    // convert to timezone Europe/Rome
    const options = { timeZone: 'Europe/Rome', hour12: false }
    const formattedDate = conv.toLocaleString('it-IT', options)
    // return formatted date in YYYY-MM-DD HH:mm:ss format
    const year = conv.getFullYear()
    const month = String(conv.getMonth() + 1).padStart(2, '0')
    const day = String(conv.getDate()).padStart(2, '0')
    const hours = String(conv.getHours()).padStart(2, '0')
    const minutes = String(conv.getMinutes()).padStart(2, '0')
    return `${year}-${month}-${day} ${hours}:${minutes}`
  }

  taskDetails (task) {

  }

  switchPorts = signal<any[]>([])
  gigabitPorts = signal<any[]>([])

  getTooltip (port: any): string {
    if (port.mac) {
      const macs = Object.entries(port.mac)
        .map(([mac, vlans]) => `MAC: ${mac}\nVLAN ID: ${(vlans as string[]).join(', ')}`)
        .join('\n\n')
      return `${port.porta}\n\n${macs || 'Nessun MAC associato'}`
    }
    if (port.macs) {
      const vlans = {}
      port.macs.forEach(m => {
        vlans[m.mac] = vlans[m.mac] ? [...vlans[m.mac], m.vlan] : [m.vlan]
      })
      const macs = Object.entries(vlans)
        .map(([mac, vlans]) => `MAC: ${mac}\nVLAN ID: ${(vlans as string[]).join(', ')}`)
        .join('\n\n')
      return `${port.porta}\n\n${macs || 'Nessun MAC associato'}`
    }
  }

  firstArray = computed(() => {
    const ports = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52]
    return this.switchPorts().length > 0 ? ports.slice(0, this.switchPorts().length / 2) : []
  })
  secondArray = computed(() => {
    const ports = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52]
    return this.switchPorts().length > 0 ? ports.slice(this.switchPorts().length / 2, this.switchPorts().length) : []
  })
  IndirizzamentoSwitch = signal<string>('')
  Marca = signal<string>('')
  ports3_4 = signal<any[]>([])
  convertBytes (bytes: number): string {
    if (bytes === 0) return '0 Bytes'
    const k = 1024
    const sizes = ['Bytes', 'KB', 'MB', 'GB']
    let i = Math.floor(Math.log(bytes) / Math.log(k))
    // Limite massimo: GB
    if (i > 3) {
      i = 3
    }
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
  }

  async getDeviceDetails (frazionario: string) {
    this.messageService.add({ severity: 'info', detail: 'Loading device details, please wait...' })
    // console.log('Fetching details for device:', deviceUUID)
    // 5 sec delay
    // await new Promise(resolve => setTimeout(resolve, 5000))
    try {
      this.workflowApiService.getFortinet_switchStatus(frazionario).subscribe(switchRes => {
        const _switch = switchRes || { switch: [] }
        this.IndirizzamentoSwitch.set(_switch.IndirizzamentoSwitch || '')
        this.Marca.set(_switch.Marca || '')
        this.switchPorts.set(_switch.switch.filter(p => !p.porta.startsWith('X')))
        this.gigabitPorts.set(_switch.switch.filter(p => !p.porta.startsWith('X')))
      })
    } catch (e) {

    }
    try {
      this.workflowApiService.getFortinet_port3_4_Status(frazionario).subscribe(switchRes => {
        // console.log(switchRes)
        this.ports3_4.set(switchRes.switch || [])
      })
    } catch (e) {

    }
    this.workflowApiService.get_FortinetDetails(frazionario).subscribe(
      (response) => {
        // console.log(response)
        this.itemDetails.set(response)
        this.newInterfaces.set(response?.interfaces ?? [])
        this.trafficBytes.set(response?.traffic || [])
        this.deviceMapFEX.set(this.deviceMAPFEX(response?.fex))
        this.deviceMap.set(this.deviceMAP(response?.device))
        if (this.interfaceList().length > 0) {
          this.workflowApiService.get_FortiGateBanda(frazionario, this.timeRange, this.interfaceList()[0]).subscribe(
            (response) => {
              this.setChartBandaOptions(response)
            },
            (error) => {
              console.error('Error fetching device statistics:', error)
              this.messageService.add({ severity: 'error', detail: 'Error fetching device statistics' })
            }
          )
        }
        if (this.interfaces1().length > 0) {
          this.interfaces1().forEach((iface: any) => {
            iface.tunnelStatus = this.getTunnelStatus(iface.name)
          })
        }
      },
      (error) => {
        console.error('Error fetching device details:', error)
        this.messageService.add({ severity: 'error', detail: 'Error fetching device details' })
      }
    )
    this.workflowApiService.get_FortiGateStatistics(frazionario).subscribe(
      (response) => {
        // console.log('Statistics response:', response)
        this.setChartOptions(response.systemStatistics)
      },
      (error) => {
        console.error('Error fetching device statistics:', error)
        this.messageService.add({ severity: 'error', detail: 'Error fetching device statistics' })
      }
    )
    this.workflowApiService.get_Fortinet_sdwanRules(frazionario).subscribe(
      (response) => {
        this.itemRules.set(response)
      },
      (error) => {
        console.error('Error fetching device statistics:', error)
        this.messageService.add({ severity: 'error', detail: 'Error fetching device statistics' })
      }
    )
    /// ////////////////////nuovo sla

    this.workflowApiService.get_sla_frazionario(frazionario, this.timeSlaRange).subscribe(
      (response: { [key: string]: any[] }) => {
        // console.log('Response object:', response);

        this.interfaces1.set(Object.entries(response).map(([name, element]) => ({
          name,
          tunnelStatus: this.getTunnelStatus(name),
          status_sla: element.map((seg: any) => seg.sla_status),
          events: element.map((seg: any) => seg.events),
          timestamp: element.map((seg: any) => seg.timestamp)
        })))

        this.chartHealtCheck(response)
        // console.log('Interfaces:', this.interfaces1);
      },
      (error) => {
        console.error('Error fetching device statistics:', error)
        this.messageService.add({ severity: 'error', detail: 'Error fetching device statistics' })
      }
    )
  }

  toggleFull (i: number) {
    const expanded = [...this.isFullExpanded()]
    expanded[i] = !expanded[i]
    this.isFullExpanded.set(expanded)

    const charts = this.slaCharts()
    if (charts[i]) {
      const updatedCharts = [...charts]
      updatedCharts[i] = {
        ...charts[i],
        option: expanded[i] ? charts[i].optionFull : charts[i].optionMini
      }
      this.slaCharts.set(updatedCharts)
    }
  }

  openTable () {
    this.view.set(!this.view())
  }

  chartHealtCheck (rowIn) {
    const slaMap = new Map<string, Map<string, SlaEvent[]>>()
    const INTERFACE_COLORS = [
      '#044880',
      '#914f30',
      '#858585',
      '#3ee6cf',
      '#74288b',
      '#1ee98a'
    ]
    const allInterfaces = Object.keys(rowIn)
    const targets = {
      HC_HUB_FTTX: { packetloss: 1, latency: 100, jitter: 3 },
      HC_HUB_MPLS: { packetloss: 1, latency: 100, jitter: 20 },
      HC_HUB_LTE: { packetloss: 3, latency: 200, jitter: 30 },
      internet_fttx: { packetloss: 1, latency: 100, jitter: 3 },
      internet_lte: { packetloss: 3, latency: 200, jitter: 30 },
      Internet: { latency: 250 }
    }
    Object.entries(rowIn).forEach(([interfaceName, segments]) => {
      const allEvents: SlaEvent[] = Array.isArray(segments) ? segments.flatMap((seg: any) => seg?.events ?? []) : []
      allEvents.forEach((event: SlaEvent) => {
        if (!slaMap.has(event.sla_name)) {
          slaMap.set(event.sla_name, new Map())
        }
        const interfaceMap = slaMap.get(event.sla_name)!
        if (!interfaceMap.has(interfaceName)) {
          interfaceMap.set(interfaceName, [])
        }
        interfaceMap.get(interfaceName)!.push(event)
      })
    })
    this.slaCharts.set([])
    slaMap.forEach((interfaceMap, slaName) => {
      const timestampSet = new Set<number>()
      interfaceMap.forEach(events => {
        events.forEach(e => timestampSet.add(e.timestamp))
      })
      const sortedTimestamps = Array.from(timestampSet).sort((a, b) => a - b)
      const series: any[] = []
      allInterfaces.forEach(interfaceName => {
        const events = interfaceMap.get(interfaceName) || []
        if (!events.length) return
        const ifIndex = allInterfaces.indexOf(interfaceName)
        const color = INTERFACE_COLORS[ifIndex % INTERFACE_COLORS.length]
        const eventMap = new Map<number, SlaEvent>(events.map(e => [e.timestamp, e]))
        const timestamps = sortedTimestamps.map(t => new Date(t * 1000))
        const latency = sortedTimestamps.map(t => eventMap.get(t)?.latency ?? null)
        const jitter = sortedTimestamps.map(t => eventMap.get(t)?.jitter ?? null)
        const packetloss = sortedTimestamps.map(t => eventMap.get(t)?.packetloss ?? null)
        series.push({
          name: interfaceName,
          type: 'line',
          xAxisIndex: 0,
          yAxisIndex: 0,
          smooth: true,
          color,
          showAllSymbol: false,
          symbol: 'emptyCircle',
          symbolSize: 4,
          sampling: 'lttb',
          data: timestamps.map((t, i) => ({
            value: [t, latency[i]],
            status: eventMap.get(sortedTimestamps[i])?.latency_status
          }))
        })
        series.push({
          name: interfaceName,
          type: 'line',
          xAxisIndex: 1,
          yAxisIndex: 1,
          smooth: true,
          color,
          showAllSymbol: false,
          symbol: 'emptyCircle',
          symbolSize: 4,
          sampling: 'lttb',
          data: timestamps.map((t, i) => ({
            value: [t, jitter[i]],
            status: eventMap.get(sortedTimestamps[i])?.jitter_status
          }))
        })
        series.push({
          name: interfaceName,
          type: 'line',
          xAxisIndex: 2,
          yAxisIndex: 2,
          smooth: true,
          color,
          showAllSymbol: false,
          symbol: 'emptyCircle',
          symbolSize: 4,
          sampling: 'lttb',
          data: timestamps.map((t, i) => ({
            value: [t, packetloss[i]],
            status: eventMap.get(sortedTimestamps[i])?.packetloss_status
          }))
        })
      })
      const slaTarget = targets[slaName]
      if (slaTarget) {
        const timestamps = sortedTimestamps.map(t => new Date(t * 1000))
        if (slaTarget.latency !== undefined) {
          series.push({
            name: 'Latency Target',
            type: 'line',
            xAxisIndex: 0,
            yAxisIndex: 0,
            color: '#e74c3c',
            symbol: 'none',
            lineStyle: {
              type: 'dashed',
              width: 2,
              color: '#e74c3c'
            },
            data: timestamps.map(t => [t, slaTarget.latency])
          })
        }
        if (slaTarget.jitter !== undefined) {
          series.push({
            name: 'Jitter Target',
            type: 'line',
            color: '#e74c3c',
            xAxisIndex: 1,
            yAxisIndex: 1,
            symbol: 'none',
            lineStyle: {
              type: 'dashed',
              width: 2,
              color: '#e74c3c'
            },
            data: timestamps.map(t => [t, slaTarget.jitter])
          })
        }
        if (slaTarget.packetloss !== undefined) {
          series.push({
            name: 'Packetloss Target',
            type: 'line',
            color: '#e74c3c',
            xAxisIndex: 2,
            yAxisIndex: 2,
            symbol: 'none',
            lineStyle: {
              type: 'dashed',
              width: 2,
              color: '#e74c3c'
            },
            data: timestamps.map(t => [t, slaTarget.packetloss])
          })
        }
      }
      const option = {
        animation: false,
        axisPointer: {
          show: true,
          link: [{ xAxisIndex: 'all' }]
        },
        tooltip: {
          trigger: 'axis',
          triggerOn: 'mousemove|click',
          renderMode: 'html',
          appendToBody: true,
          confine: true,
          axisPointer: {
            type: 'cross',
            snap: true
          },
          formatter: (params: any[]) => {
            if (!params || !params.length) return ''
            const date = new Date(params[0].axisValue)
            const metricNames = [
              { name: 'Latency', unit: ' ms' },
              { name: 'Jitter', unit: ' ms' },
              { name: 'Packet Loss', unit: ' %' }
            ]
            const grouped: any = {}
            params.forEach(p => {
              const metricIndex = p.axisIndex
              if (!grouped[metricIndex]) {
                grouped[metricIndex] = []
              }
              grouped[metricIndex].push(p)
            })
            let html = `
      <div class="font-bold mb-2.5">
        ${date.toLocaleString('it-IT')}
      </div>
      <div class="flex gap-[30px] items-flex-start">`
            Object.keys(grouped).forEach(index => {
              const metric = metricNames[+index]
              html += `<div> <div class="font-semibold mb-1.5">${metric.name}</div>`
              grouped[index].forEach((p: any) => {
                const value = p.value[1]

                const status = p.data?.status
                const color = status === 'KO' ? '#e74c3c' : '#333'
                html += `<div class="whitespace-nowrap"> ${p.marker} ${p.seriesName}: <b class="text-[${color}]">${value ?? '-'}${metric.unit}</b> </div>`
              })
              html += '</div>'
            })
            html += '</div>'
            return html
          }
        },
        dataZoom: [
          {
            type: 'slider',
            xAxisIndex: [0, 1, 2],
            filterMode: 'filter',
            height: 15,
            bottom: 8
          },
          {
            type: 'inside',
            xAxisIndex: [0, 1, 2],
            filterMode: 'filter'
          }
        ],
        legend: {
          orient: 'vertical',
          right: 10,
          top: 'top',
          type: 'scroll'
        },
        grid: [
          { top: 40, height: '25%', left: 60, right: 180 },
          { top: '38%', height: '25%', left: 60, right: 180 },
          { top: '70%', height: '25%', left: 60, right: 180 }
        ],
        xAxis: [
          { type: 'time', gridIndex: 0, axisPointer: { show: true } },
          { type: 'time', gridIndex: 1, axisPointer: { show: true } },
          { type: 'time', gridIndex: 2, axisPointer: { show: true } }
        ],
        yAxis: [
          { type: 'value', name: 'Latency (ms)', gridIndex: 0 },
          { type: 'value', name: 'Jitter (ms)', gridIndex: 1 },
          { type: 'value', name: 'Packet Loss (%)', gridIndex: 2 }
        ],
        series
      }
      const optionMini = {
        ...option,
        legend: { ...option.legend, textStyle: { fontSize: 8 }, itemWidth: 10, itemHeight: 6 },
        grid: [
          { top: 25, height: 70, left: 45, right: 100 },
          { top: 130, height: 70, left: 45, right: 100 },
          { top: 235, height: 70, left: 45, right: 100 }
        ],
        xAxis: option.xAxis.map((ax: any) => ({ ...ax, axisLabel: { fontSize: 8 } })),
        yAxis: option.yAxis.map((ax: any) => ({ ...ax, axisLabel: { fontSize: 8 }, nameTextStyle: { fontSize: 8 } })),
        series: series.map((s: any) => ({ ...s, symbolSize: 3, lineStyle: { width: 1 } }))
      }
      this.slaCharts.set([...this.slaCharts(), {
        slaName,
        option: optionMini,
        optionMini,
        optionFull: option
      }])
    /*  this.slaCharts.push({
        slaName,
        option
      }); */
    })
  }

  toggleStatus (rowIn: any, item: string) {
    const newValue = !rowIn[item]
    const obj = {
      frazionario: this._frazionario,
      vlan: rowIn.name,
      status: newValue ? 'up' : 'down'
    }
    this.workflowApiService.updateVlanStatusfortinet(obj).subscribe((data) => {
      this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Status updated' })
      this.workflowApiService.get_FortinetDetails(this._frazionario).subscribe(
        (response) => {
          this.itemDetails.set(response)
          this.newInterfaces.set(response?.interfaces ?? [])
          if (this.interfaceList().length > 0) {
            this.workflowApiService.get_FortiGateBanda(this._frazionario, this.timeRange, this.interfaceList()[0]).subscribe(
              (response) => {
                this.setChartBandaOptions(response)
              },
              (error) => {
                console.error('Error fetching device statistics:', error)
                this.messageService.add({ severity: 'error', detail: 'Error fetching device statistics' })
              }
            )
          }
          if (this.interfaces1().length > 0) {
            this.interfaces1().forEach((iface: any) => {
              iface.tunnelStatus = this.getTunnelStatus(iface.name)
            })
          }
        },
        (error) => {
          console.error('Error fetching device details:', error)
          this.messageService.add({ severity: 'error', detail: 'Error fetching device details' })
        }
      )
    }, error => {
      console.log(error)
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error updating status ' })
    })
  }

  confirmRebootFex () {
    this.fqConfirm.confirm({
      header: 'Confirm FEX Reboot',
      message: 'Do you want to proceed?',
      action: 'primary',
      acceptLabel: 'Confirm'
    }).then(ok => { if (ok) this.rebootFex() })
  }

  rebootFex () {
    const obj = {
      frazionario: this._frazionario
    }
    this.workflowApiService.reboot_Fex(obj).subscribe((data) => {
      this.messageService.add({ severity: 'success', summary: 'Success', detail: 'FEX rebooted' })
    }, error => {
      console.log(error)
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error rebooting FEX ' })
    })
  }

  formatTimestamp (ts: number): string {
    const date = new Date(ts * 1000)
    const day = String(date.getDate()).padStart(2, '0')
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const year = date.getFullYear()
    const hours = String(date.getHours()).padStart(2, '0')
    const minutes = String(date.getMinutes()).padStart(2, '0')
    const seconds = String(date.getSeconds()).padStart(2, '0')

    return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`
  }

  fexLoading = false
  getFEXInfo () {
    this.fexLoading = true
    this.workflowApiService.getFEXInfo(this._frazionario).subscribe(
      (response) => {
        console.log('FEX Info:', response)
        if (response && response.data) {
          this.deviceMapFEX.set([...this.deviceMapFEX(), { header: 'IP', value: response.data.port4_ip }])
          this.deviceMapFEX.set([...this.deviceMapFEX(), { header: 'Port4 MAC', value: response.data.port4_mac }])
        }
      },
      (error) => {
        console.error('Error fetching FEX info:', error)
      },
      () => {
        this.fexLoading = false
      }
    )
  }

  resetHealtCheck () {
    this.interfaces1.set([])
    this.segmentData = []
    this.extendedView = false
    this.segmentGroups = []
    this.segmentKeys = []
    this.showOnlyKo = false
  }

  interfaces1 = signal<any[]>([])
  segmentData: any[] = []
  segmentKeys: string[] = []
  dialogInfoChart = false
  segmentGroups: any[] = []
  extendedView = false
  interfaceDetails: any = null
  onSegmentClick (iface: any, seg: any, idx: number) {
    this.interfaceDetails = iface.name
    const events = iface.events[idx]
    // console.log(events)
    if (!events || !events.length) {
      return
    }
    const grouped = events.reduce((acc: any, curr: any) => {
      if (!acc[curr.timestamp]) {
        acc[curr.timestamp] = []
      }
      acc[curr.timestamp].push(curr)
      return acc
    }, {})
    this.segmentGroups = Object.values(grouped).sort((a: any, b: any) => a[0].timestamp - b[0].timestamp)
    /* this.segmentKeys = Object.keys(this.segmentGroups[0][0]).filter(k => k !== 'timestamp'); */
    const allowedKeys = ['jitter', 'latency', 'packetloss', 'sla_status']
    this.segmentKeys = Object.keys(this.segmentGroups[0][0]).filter(k => allowedKeys.includes(k))
    this.extendedView = false
    this.dialogInfoChart = true
  }

  showOnlyKo = false
  get koTimestampsCount (): number {
    return this.segmentGroups.filter(group => group.some(item => item.sla_status === 'KO')).length
  }

  hasKo (group: any[]): boolean {
    return group.some(item => item.sla_status === 'KO')
  }

  get isKoFilterDisabled (): boolean {
    return (
      this.koTimestampsCount === 0 || this.koTimestampsCount === this.segmentGroups.length)
  }

  toggleView () {
    this.extendedView = !this.extendedView
  }

  closeDialog () {
    this.dialogInfoChart = false
    this.extendedView = false
    this.segmentGroups = []
    this.segmentKeys = []
    this.showOnlyKo = false
  }

  getTooltipSegment (iface: any, seg: any, idx: number) {
    return iface.timestamp[idx]
  }

  getMetricClass (item: any, key: string): string {
    const monitoredKeys = ['jitter', 'latency', 'packetloss']
    if (!monitoredKeys.includes(key)) {
      return ''
    }
    const statusKey = key + '_status'
    const status = item[statusKey]
    if (status === 'KO') {
      return 'metric-ko'
    }
    return ''
  }

  goBack () {
    this.router.navigate(['/awpDashboardCisco/ciscoSummary']).then(success => {
      if (!success) { this.messageService.add({ severity: 'warn', detail: 'Error' }) }
    }).catch(err => console.log(err))
  }

  avgCPU = computed(() => {
    const data = this.rawData()
    return data.length ? Math.round(data.reduce((acc, curr) => acc + curr.cpu_system, 0) / data.length) : 0
  })
  avgRAM = computed(() => {
    const data = this.rawData()
    return data.length ? Math.round(data.reduce((acc, curr) => acc + curr.mem_util, 0) / data.length) : 0
  })
  setChartOptions (rawData) {
    this.rawData.set(rawData || [])
    this.chartOption.set({
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow'
        }
      },
      legend: {
        top: '5%',
        left: 'center'
      },
      xAxis: {
        type: 'time',
        axisLabel: {
          formatter: (value) => {
            const date = new Date(value)
            return date.toLocaleTimeString()
          }
        }
      },
      yAxis: {
        type: 'value',
        axisLabel: {
          formatter: (value) => `${value}%`
        }
      },
      dataZoom: [
        {
          id: 'dataZoomX',
          type: 'slider',
          xAxisIndex: [0],
          filterMode: 'filter',
          start: 0,
          end: 100,
          height: '5%',
          bottom: 15,
          margin: 10
        },
        {
          id: 'dataZoomY',
          type: 'slider',
          yAxisIndex: [0],
          filterMode: 'empty',
          start: 0,
          end: 100,
          width: 15,
          left: '96%'
        },
        {
          type: 'inside'
        }
      ],
      series: [
        {
          name: 'CPU',
          type: 'bar',
          smooth: true,
          data: rawData.map(d => [d.entry_time, d.cpu_system]),
          barWidth: 10,
          markLine: {
            data: [{ type: 'average', name: 'Avg' }]
          },
          itemStyle: {
            borderRadius: 5,
            color: new graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: '#19549f' },
              { offset: 1, color: '#334155' }
            ])
          }
        },
        {
          name: 'Memory',
          type: 'line',
          smooth: true,
          data: rawData.map(d => [d.entry_time, d.mem_util]), // Math.round(d.mem_util * 100)]),
          showAllSymbol: true,
          symbol: 'emptyCircle',
          symbolSize: 5
        }
      ]
    })
  }

  // hasData = false
  timeRange: string = 'hour'
  chartInterface: string = ''
  chartOptionBanda = signal<any>({})
  rawDataBanda: any[] = []
  // avgRX: number = 0;
  // avgTX: number = 0;
  maxRX = signal<string>('')
  maxTX = signal<string>('')
  timeSlaRange = '10min'
  onTimeSlaChange (event: any) {
    this.timeSlaRange = event.target.value
    this.workflowApiService.get_sla_frazionario(this._frazionario, this.timeSlaRange).subscribe(
      (response: { [key: string]: any[] }) => {
        this.interfaces1.set(Object.entries(response).map(([name, element]) => ({
          name,
          tunnelStatus: this.getTunnelStatus(name),
          status_sla: element.map((seg: any) => seg.sla_status),
          events: element.map((seg: any) => seg.events),
          timestamp: element.map((seg: any) => seg.timestamp)
        })))
        this.chartHealtCheck(response)
        this.view.set(false)
        this.isFullExpanded.set([])
      },
      (error) => {
        console.error('Error fetching device statistics:', error)
        this.messageService.add({ severity: 'error', detail: 'Error fetching device statistics' })
      }
    )
  }

  onTimeRangeChange (event: any, type: 'timeRange' | 'chartInterface') {
    if (type === 'timeRange') {
      this.timeRange = event.target.value
    } else if (type === 'chartInterface') {
      this.chartInterface = event.target.value
    }
    // const newRange = event.target.value
    this.loadBandwidthData(this.timeRange, this.chartInterface)
  }

  loadBandwidthData (range: string, iface: string) {
    if (!iface || iface === '') {
      this.chartInterface = this.interfaceList().length > 0 ? this.interfaceList()[0] : ''
      iface = this.chartInterface
    }
    this.workflowApiService.get_FortiGateBanda(this._frazionario, range, iface).subscribe(
      (response) => {
        this.setChartBandaOptions(response)
      },
      (error) => {
        console.error('Error:', error)
        this.messageService.add({ severity: 'error', detail: 'Errore caricamento banda' })
      }
    )
  }

  setChartBandaOptions (payload: BandwidthResponse) {
    if (!payload || !payload.rx?.length || !payload.tx?.length) {
      this.chartOptionBanda.set({})
      //  this.hasData = false
      return
    }
    //   this.hasData = true
    const rxData = payload.rx
    const txData = payload.tx
    /* this.avgRX = Math.round(
    rxData.reduce((acc, curr) => acc + curr.bps, 0) / rxData.length
  );
  this.avgTX = Math.round(
    txData.reduce((acc, curr) => acc + curr.bps, 0) / txData.length
  ); */
    const formatBits = (bps: number, decimals = 2): string => {
      if (!bps || bps === 0) return '0 bps'
      const k = 1000
      const sizes = ['bps', 'Kbps', 'Mbps', 'Gbps', 'Tbps']
      const i = Math.floor(Math.log(Math.abs(bps)) / Math.log(k))
      return (
        parseFloat((bps / Math.pow(k, i)).toFixed(decimals)) +
      ' ' +
      sizes[i]
      )
    }
    const rawMaxRX = Math.max(...rxData.map(p => p.bps))
    const rawMaxTX = Math.max(...txData.map(p => p.bps))
    this.maxRX.set(formatBits(rawMaxRX))
    this.maxTX.set(formatBits(rawMaxTX))
    this.chartOptionBanda.set({
      title: {
        text: `Traffic History - Interface: ${this.chartInterface}`,
        left: 'center', // centra il titolo
        top: -5, // distanza dal bordo
        textStyle: {
          fontSize: 16,
          fontWeight: 'bold',
          color: '#333'
        }

      },
      tooltip: {
        trigger: 'axis',
        axisPointer: { type: 'cross' },
        formatter: (params: any[]) => {
          const date = new Date(params[0].axisValue)
          let html = `<strong>${date.toLocaleString('it-IT')}</strong><br/>`
          params.forEach(p => {
            html += `${p.marker} ${p.seriesName}: <b>${formatBits(p.value[1] * 1000)}</b><br/>`
          })
          return html
        }
      },
      legend: {
        top: '6%',
        left: 'center',
        data: ['RX (Download)', 'TX (Upload)']
      },
      xAxis: {
        type: 'time',
        axisLabel: {
          formatter: (value: number) => {
            const d = new Date(value)
            return d.toLocaleTimeString('it-IT', {
              hour: '2-digit',
              minute: '2-digit'
            })
          }
        }
      },
      yAxis: {
        type: 'value',
        axisLabel: {
          formatter: (value: number) => formatBits(value * 1000)
        }
      },
      dataZoom: [
        {
          id: 'dataZoomX',
          type: 'slider',
          xAxisIndex: [0],
          filterMode: 'filter',
          start: 0,
          end: 100,
          height: '5%',
          bottom: 10,
          margin: 15
        },
        {
          id: 'dataZoomY',
          type: 'slider',
          yAxisIndex: [0],
          filterMode: 'empty',
          start: 0,
          end: 100,
          width: 15,
          left: '96%'
        },
        {
          type: 'inside'
        }
      ],
      series: [
        {
          name: 'RX (Download)',
          type: 'line',
          smooth: true,
          data: rxData.map(p => [p.utc_ms, p.bps / 1000]),
          showAllSymbol: false,
          symbol: 'emptyCircle',
          symbolSize: 4,
          markLine: {
            data: [{ type: 'average', name: 'Avg RX' }],
            label: {
              formatter: (p: any) => formatBits(p.value * 1000)
            }
          }
        },
        {
          name: 'TX (Upload)',
          type: 'line',
          smooth: true,
          data: txData.map(p => [p.utc_ms, p.bps / 1000]),
          showAllSymbol: false,
          symbol: 'emptyCircle',
          symbolSize: 4,
          markLine: {
            data: [{ type: 'average', name: 'Avg TX' }],
            label: {
              formatter: (p: any) => formatBits(p.value * 1000)
            }
          }
        }
      ]
    })
  }

  getInterfaceIcon (type: string): string {
    switch (type) {
      case 'physical':
        return 'fa-solid fa-network-wired text-fq-info'
      case 'tunnel':
        return 'fa-solid fa-circle-notch text-fq-info'
      case 'vlan':
        return 'fa-solid fa-diagram-project text-fq-info'
      case 'loopback':
        return 'fa-solid fa-rotate text-fq-info'

      case 'fext-wan':
        return 'fa-solid fa-signal text-fq-info'
      default:
        return 'fa-solid fa-circle'
    }
  }
}


